<div class="scroll-indicator" [class.visible]="isVisible" [style.left.px]="indicatorLeftPosition" data-testid="scroll-indicator">
  <div class="scroll-indicator-content">
    <span *ngIf="showText" class="scroll-text kh-text-primary text-uppercase" data-testid="scroll-indicator-text">
      {{text}}
    </span>
    <img [src]="iconSrc" alt="Scroll down icon" class="scroll-icon" data-testid="scroll-indicator-icon">
  </div>
</div>
